import React, { PureComponent } from 'react';
import { connect } from 'dva';
import AWSCredentials from './CredentialsForm/AWSCredentials';
import AzureCredentialForm from './CredentialsForm/AzureCredentialForm';
import GCPCredentialForm from './CredentialsForm/GCPCredentialForm';

@connect(({ cloudAccount }) => ({
  authKey: cloudAccount.authorizerSecretKey,
  cloudAccountIdRef: cloudAccount.cloudAccountIdRef,
}))
class AuthenticationMethod extends PureComponent {
  render() {
    const { authKey, cloudAccountIdRef, roleNames } = this.props;
    const { awsData, azureData, gcpData } = this.props.authData;
    return (
      // Will add more forms for get Credentials for new cloud
      this.props.accountProvider === 'AWS' ? (
        <AWSCredentials
          cloudAccountIdRef={cloudAccountIdRef}
          authKey={authKey}
          sentRequireData={this.props}
          setFormRef={this.props.setFormRef}
          authData={awsData}
        />
      ) : this.props.accountProvider === 'AZURE' ? (
        <AzureCredentialForm
          sentRequireData={this.props}
          setFormRef={this.props.setFormRef}
          authData={azureData}
        />
      ) : (
        <GCPCredentialForm
          sentRequireData={this.props}
          setFormRef={this.props.setFormRef}
          authData={gcpData}
          authKey={authKey}
          roleNames={roleNames}
        />
      )
    );
  }
}

export default AuthenticationMethod;
